import { Environment } from '@coolblue-development/constants';
export function getFlirtBaseUrl(environment) {
    if (environment === Environment.PRODUCTION) {
        return 'https://flirt.office.coolblue.nl/Flirt';
    }
    else if (environment === Environment.ACCEPTANCE) {
        return 'https://flirt.accept.zone/Flirt';
    }
    else if (environment === Environment.TESTING) {
        return 'https://flirt.tst.zone/Flirt';
    }
    else {
        return 'https://flirt.tst.zone/Flirt';
    }
}
//# sourceMappingURL=getFlirtBaseUrl.js.map